var styles = {
  "SkipLink": "_SkipLink_1jwcn_1"
};

export { styles as default };
